/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'team-central.give-jira-kudos.created.description.flag': 'Unser Workplace Experience-Team wird sich nun um die Geschenkeanfrage kümmern. ✨',
  'team-central.give-jira-kudos.created.title.flag': 'Lob erstellt',
  'team-central.give-jira-kudos.creation.failed.description.flag': 'Ihr Lob konnte nicht erstellt und das Geschenk nicht gesendet werden. Versuchen Sie, ein separates Ticket bei <a>go/kudos</a> zu kaufen.',
  'team-central.give-jira-kudos.creation.failed.title.flag': 'Etwas ist schiefgelaufen',
  'team-central.give-kudos.button': 'Loben',
  'team-central.give-kudos.close-button.label': 'Drawer schließen',
  'team-central.give-kudos.confirm-close.title': 'Schließen bestätigen',
  'team-central.give-kudos.created.description.flag': 'Ihr Lob wurde gesendet. <a>Lob anzeigen</a>',
  'team-central.give-kudos.created.title.flag': 'Lob erstellt',
  'team-central.give-kudos.creation.failed.description.flag': 'Ihr Lob konnte nicht erstellt werden.',
  'team-central.give-kudos.creation.failed.title.flag': 'Etwas ist schiefgelaufen',
  'team-central.give-kudos.error-icon.label': 'Fehler',
  'team-central.give-kudos.success-icon.label': 'Erfolgreich',
  'team-central.give-kudos.unsaved.warning': 'Von Ihnen vorgenommene Änderungen werden nicht gespeichert.',
  'team-central.give-kudos.unsaved.warning.cancel': 'Abbrechen',
  'team-central.give-kudos.unsaved.warning.close': 'Schließen'
};